import { saveAs } from 'file-saver';
import { LogsArchivingService } from './../logs-archiving.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Component, OnInit } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-logs-archiving',
  templateUrl: './logs-archiving.component.html',
  styleUrls: ['./logs-archiving.component.scss'],
  providers: [
    LogsArchivingService
  ]
})
export class LogsArchivingComponent implements OnInit {

  public dateStart: any;
  public dateEnd: string;
  public documents: any[];

  // Paginação
  public qtdPorPagina: number = 10;
  public qtdPorPaginaCustom: number = 10;
  public currentPage: number = 0;
  public page: number = 0;
  public resultCount: number = 0;

  // Ordenação
  public orderby = 'Date';
  public sort = 'asc';

  // Option to datepicker
  private myDatePickerOptions: IMyDpOptions = {
    // other options...
    dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
    monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
    dateFormat: 'dd/mm/yyyy',
    showTodayBtn: false,
    //disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
    //disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
    //disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
    //editableDateField: false,
    //height: "30px"
  };

  constructor(
    private flashMessagesService: FlashMessagesService,
    private logsArchivingService: LogsArchivingService
  ) { }

  ngOnInit() {
    // Do nothing until someone picks a range to filter!
  }

  setOrder(orderby) {
    if (this.orderby != orderby) {
      this.sort = 'asc';
    } else {
      this.sort = this.sort == 'asc' ? 'desc' : 'asc';
    }
    this.orderby = this.orderby != orderby ? orderby : this.orderby;
    this.searchS3Log();
  }

  changePerPage() {
    this.qtdPorPagina = this.qtdPorPaginaCustom;
    this.currentPage = 0;
    this.searchS3Log();
  }

  paginar($event: any) {
    this.currentPage = $event;
    this.page = $event;
    this.searchS3Log();
  }

  searchS3Log() {
    const periodo = {
      dataInicio: this.dateStart['date']['year']
        + '-' + this.dateStart['date']['month']
        + '-' + this.dateStart['date']['day']
        + ' 00:00:00',
      dataFim: this.dateEnd['date']['year']
        + '-' + this.dateEnd['date']['month']
        + '-' + this.dateEnd['date']['day']
        + ' 00:00:00'
    };

    if (moment(periodo.dataFim) < moment(periodo.dataInicio)) {
      // tslint:disable-next-line: max-line-length
      this.flashMessagesService.show('Período inválido! A data inicial não pode ser maior que a data final', { cssClass: 'alert-danger', timeout: 6000 });
      return;
    }

    periodo.dataInicio = periodo.dataInicio ? moment(periodo.dataInicio).startOf('day').format('YYYY-MM-DD HH:mm:ss') : null;
    periodo.dataFim = periodo.dataFim ? moment(periodo.dataFim).endOf('day').format('YYYY-MM-DD HH:mm:ss') : null;

    this.logsArchivingService.getLogs(periodo, this.orderby, this.sort, this.currentPage, this.qtdPorPagina).subscribe(result => {
      this.documents = result ? result.Result : [];
      this.resultCount = result ? result.Count : 0;
      console.log(this.documents);
    });
  }


  // Download dos arquivos do Bucket
  downloadAttachment(fileName, fileDate) {
    this.logsArchivingService.downloadAttachment(fileName).subscribe(result => {
      if (result) {
        const year = moment(fileDate).format('YYYY');
        const month = moment(fileDate).format('MM');
        const day = moment(fileDate).format('DD');
        // const name = fileName.replace('.csv', '');
        console.log(result);
        saveAs(result, `${day}_${month}_${year}_${fileName}`);
      } else {
        this.flashMessagesService.show('Problema ao baixar o arquivo', { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log('deu ruim', error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/logs-archiving/component/logs-archiving.component.ts